import { render, staticRenderFns } from "./LightDashboard.vue?vue&type=template&id=b567bdc6&scoped=true"
import script from "./LightDashboard.vue?vue&type=script&lang=js"
export * from "./LightDashboard.vue?vue&type=script&lang=js"
import style0 from "./LightDashboard.vue?vue&type=style&index=0&id=b567bdc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b567bdc6",
  null
  
)

export default component.exports